 
import { authStore } from '../store/AuthStore';
import { debuglog, logerror } from './util';

 

// BASE URL
 
const s3Url = process.env.REACT_APP_BASE_S3_CLOUDFRONT_URL + '/';


const getAPIBase = () => {
 

    // return `https://api.staging.app.familydoctor.com.au/graphql`;
    return process.env.REACT_APP_FDAPIV2_BASE_URL+ '/';
  };

const checkResponseAndParseJson = async (res: Response): Promise<any> => {
    // Check if the response status is not OK (2xx range)
    if (!res.ok) {
        let errorJson: any;

        // Attempt to parse the error response as JSON
        try {
            errorJson = await res.json();
        } catch {
            // If JSON parsing fails, throw a generic error with the response status
            throw new Error(`Request failed with status ${res.status}: ${res.statusText}`);
        }

        // If the parsed JSON contains an "error" field, throw that error
        if (errorJson && typeof errorJson === 'object' && 'error' in errorJson) {
            throw new Error("Error:" + JSON.stringify(errorJson));
        }

        // Otherwise, throw a generic error with the response status
        throw new Error(`Request failed with status ${res.status}: ${res.statusText}`);
    }

    // If the response is OK, parse and return the JSON body
    return res.json();
};

// GET
export async function get(path: string, queryParams?: string[][] | Record<string, string> | string | URLSearchParams): Promise<unknown> {
    if (queryParams) {
        path = path + '?' + new URLSearchParams(queryParams).toString();
    }
    const response = await fetch(getAPIBase() + path, {
        method: 'GET',
        headers: await createHeaders(),
    })
        .then(async (res) => await checkResponseAndParseJson(res))
        .catch((err) => {
            logerror({uri:getAPIBase()+path, err});
            throw err;
        });
    return response;
}

// POSTS

export async function postForm(path: string, body: BodyInit, queryParams?: string[][] | Record<string, string> | string | URLSearchParams): Promise<unknown> {
    if (queryParams) {
        path = path + '?' + new URLSearchParams(queryParams).toString();
    }
    const response = await fetch(getAPIBase() + path, {
        method: 'POST',
        body,
        headers: await createHeaders(),
    })
        .then(async (res) => await checkResponseAndParseJson(res))
        .catch((err) => {
            logerror({uri:getAPIBase()+path, err});
            throw err;
        });
    return response;
}

export async function post(path: string, body: any, queryParams?: string[][] | Record<string, string> | string | URLSearchParams): Promise<unknown> {
    if (queryParams) {
        path = path + '?' + new URLSearchParams(queryParams).toString();
    }
    const response = await fetch(getAPIBase() + path, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: await createHeaders(),
    })
        .then(async (res) => await checkResponseAndParseJson(res))
        .catch((err) => {
            logerror({uri:getAPIBase()+path, err});
            throw err;
        });
    debuglog('post response:', response);
    return response;
}

export async function postForFileDownload(path: string, body: any, queryParams?: string[][] | Record<string, string> | string | URLSearchParams): Promise<unknown> {
    if (queryParams) {
        path = path + '?' + new URLSearchParams(queryParams).toString();
    }
    const response = await fetch(getAPIBase() + path, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: await createHeaders(),
    })
        .then(async (res) => res)
        .catch((err) => {
            throw err;
        });
    return response;
}

export async function put(path: string, body: any, queryParams?: string[][] | Record<string, string> | string | URLSearchParams): Promise<Record<string, any>> {
    if (queryParams) {
        path = path + '?' + new URLSearchParams(queryParams).toString();
    }
    const response = await fetch(getAPIBase() + path, {
        method: 'PUT',
        body: JSON.stringify(body),
        headers: await createHeaders(),
    })
        .then(async (res) => await checkResponseAndParseJson(res))
        .catch((err) => {
            logerror({uri:getAPIBase()+path, err});
            throw err;
        });
    return response;
}

export async function putS3File(fileName: string, contentType: string, body: any): Promise<boolean> {
    const response = await fetch(s3Url + fileName, {
        method: 'PUT',
        body: body,
        headers: await createHeaders(contentType),
    })
        .then(async (res) => res.ok)
        .catch((err) => {
            throw err;
        });
    return response;
}

export async function remove(path: string, queryParams?: string[][] | Record<string, string> | string | URLSearchParams): Promise<Record<string, any>> {
    if (queryParams) {
        path = path + '?' + new URLSearchParams(queryParams).toString();
    }
    const response = await fetch(getAPIBase() + path, {
        method: 'DELETE',
        headers: await createHeaders(),
    })
        .then(async (res) => await checkResponseAndParseJson(res))
        .catch((err) => {
            throw err;
        });
    return response;
}

const createHeaders = async (contentType?: string): Promise<Headers> => {
    let headers = new Headers();
    const accessToken = await authStore.getAccessToken();
    if ((accessToken !== undefined) && (accessToken !== ""))  headers.append('Authorization', 'Bearer ' + (await authStore.getAccessToken()));
    headers.append('Content-Type', 'application/json');
    if (contentType) headers.set('Content-Type', contentType);

    return headers;
};
